import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

export default function ForgotPassword({ navigateTo }) {
  const { forgotPassword } = useAuth();
  const [identifier, setIdentifier] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [whatsappUrl, setWhatsappUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setWhatsappUrl('');

    if (!identifier.trim()) {
      setError('لطفاً ایمیل یا شماره موبایل خود را وارد کنید');
      return;
    }

    setLoading(true);

    try {
      const result = await forgotPassword(identifier.trim());

      if (result.success) {
        setSuccess(result.message);
        setWhatsappUrl(result.whatsappUrl);
      } else {
        setError(result.message);
      }

    } catch (requestError) {
      setError(requestError.response?.data?.message || 'ثبت درخواست بازیابی انجام نشد');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>فراموشی رمز عبور</h2>
          <p>ایمیل یا شماره موبایل خود را وارد کنید</p>
        </div>

        <div className="auth-body">
          <button
            className="back-to-shop"
            onClick={() => navigateTo('login')}
          >
            ← بازگشت به صفحه ورود
          </button>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          {whatsappUrl && (
            <div className="info-message" style={{
              backgroundColor: '#f0f8ff',
              border: '1px solid #3498db',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '20px',
              direction: 'ltr',
              textAlign: 'left',
              fontSize: '12px',
              wordBreak: 'break-all'
            }}>
              <strong>مرحله بعد:</strong><br />
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                ارسال درخواست در واتساپ
              </a>
              <p style={{ marginTop: '10px', fontSize: '11px', color: '#666' }}>
                پیام آماده را از همان شماره ثبت‌شده برای نقش خیال ارسال کنید.
              </p>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{textAlign:'right'}}>ایمیل یا شماره موبایل</label>
              <input
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="example@email.com یا 09123456789"
                dir="ltr"
              />
            </div>

            <button
              type="submit"
              className="auth-button"
              disabled={loading}
            >
              {loading ? 'در حال ثبت...' : 'ثبت درخواست بازیابی'}
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <p>رمز عبور خود را به خاطر آوردید؟</p>
          <button onClick={() => navigateTo('login')}>
            ورود به حساب کاربری
          </button>
        </div>
      </div>
    </div>
  );
}
